import { SelectItem } from "@/models/api/SelectItem";
import {
  ServiceTypeListItem,
  ServiceTypeCategory,
  ServiceTypesCategorizedResponse,
  ServiceTypesResponse,
} from "@/models/api/serviceTypes/ServiceTypeListItem";
import { IntKeyValue } from "@/models/api/IntKeyValue";
import { SERVICE_CATEGORY } from "@/static/serviceCategory";
import CancellableHelper from "@/requests/CancellableHelper";
import GenericTableRequest from "@/models/api/GenericTableRequest";
import { ServiceTypeFull } from "@/models/api/serviceTypes/ServiceTypeFull";

//#region Routes
export const URL_GET_SERVICE_TYPES_SIMPLE = "/ServiceType/ServiceTypesSimple/${Category}";
export const URL_GET_SERVICE_TYPES = "/ServiceType/ServiceTypes/${Category}";
export const URL_GET_SELECTED_SERVICE_TYPES = "/ServiceType/SelectedServiceTypes/${Category}";
export const URL_GET_SERVICE_TYPES_FOR_DOCUMENT_TYPE = "/ServiceType/ServiceTypesForDocumentType/${DocumentTypeId}";
export const URL_GET_SERVICE_TYPES_WITH_LOCKED = "/ServiceType/ServiceTypesWithLocked/${OnlySale}";
export const URL_GET_SERVICE_TYPE_CATEGORIZED = "/ServiceType/ServiceTypesCategorized/${GDSId}";

export const URL_GET_SERVICE_TYPE = "/ServiceType/${ServiceTypeId}";
export const URL_GET_TRADE_TERM_TYPES = "/ServiceType/TradeTermType";
export const URL_GET_COMMISSION_SERVICE_TYPE = "/ServiceType/${CommissionServiceTypeId}/CommissionServiceType";
export const URL_GET_TRADE_TERMS_FOR_BOOKING = "/ServiceType/GetTradeTermsForBooking";
//#endregion

export interface SelectedServiceTypes {
  isInverted: boolean;
  page: number;
  count: number;
  selected: Array<number>;
}

const _getServiceTypesSimple = new CancellableHelper<Array<SelectItem>>(URL_GET_SERVICE_TYPES_SIMPLE, SelectItem);
export const getServiceTypesSimple = async (category: SERVICE_CATEGORY): Promise<Array<SelectItem>> => {
  return await _getServiceTypesSimple.get({ Category: category });
};

const _getSaleServiceTypes = new CancellableHelper<ServiceTypesResponse>(URL_GET_SERVICE_TYPES, ServiceTypesResponse);
_getSaleServiceTypes.jsonSerializer = true;
export const getServiceTypes = async (
  category: SERVICE_CATEGORY,
  genericTableRequest: GenericTableRequest
): Promise<ServiceTypesResponse> => {
  return await _getSaleServiceTypes.get({ Category: category, ...genericTableRequest });
};

const _getSelectedServiceTypes = new CancellableHelper<ServiceTypesResponse>(
  URL_GET_SELECTED_SERVICE_TYPES,
  ServiceTypesResponse
);
export const getSelectedServiceTypes = async (
  category: SERVICE_CATEGORY,
  model: SelectedServiceTypes
): Promise<ServiceTypesResponse> => {
  return await _getSelectedServiceTypes.post({ Category: category }, model);
};

const _getServiceTypesForDocumentType = new CancellableHelper<ServiceTypesResponse>(
  URL_GET_SERVICE_TYPES_FOR_DOCUMENT_TYPE,
  ServiceTypesResponse
);
_getServiceTypesForDocumentType.jsonSerializer = true;
export const getServiceTypesForDocumentType = async (
  documentTypeId: number,
  genericTableRequest: GenericTableRequest
): Promise<ServiceTypesResponse> => {
  return await _getServiceTypesForDocumentType.get({ DocumentTypeId: documentTypeId, ...genericTableRequest });
};

const _getServiceTypesWithLocked = new CancellableHelper<ServiceTypesResponse>(
  URL_GET_SERVICE_TYPES_WITH_LOCKED,
  ServiceTypesResponse
);
_getServiceTypesWithLocked.jsonSerializer = true;
export const getServiceTypesWithLocked = async (
  onlySale: boolean,
  genericTableRequest: GenericTableRequest
): Promise<ServiceTypesResponse> => {
  return await _getServiceTypesWithLocked.get({ OnlySale: onlySale, ...genericTableRequest });
};

const _getServiceTypesCategorized = new CancellableHelper<ServiceTypesCategorizedResponse>(
  URL_GET_SERVICE_TYPE_CATEGORIZED,
  ServiceTypeCategory
);
export const getServiceTypesCategorized = async (gdsId: number): Promise<ServiceTypesCategorizedResponse> => {
  return await _getServiceTypesCategorized.get({ GDSId: gdsId });
};

const _getTradeTermsForBooking = new CancellableHelper<Array<SelectItem>>(URL_GET_TRADE_TERMS_FOR_BOOKING, SelectItem);
export const getTradeTermsForBooking = async (): Promise<Array<SelectItem>> => {
  return await _getTradeTermsForBooking.get();
};

const _getTradeTermTypes = new CancellableHelper<Array<IntKeyValue>>(URL_GET_TRADE_TERM_TYPES, IntKeyValue);
export const getTradeTermTypes = async (): Promise<Array<IntKeyValue>> => {
  return await _getTradeTermTypes.get();
};

const _getCommissionServiceType = new CancellableHelper<ServiceTypeListItem>(URL_GET_COMMISSION_SERVICE_TYPE);
export const getCommissionServiceType = async (baseServiceId: number): Promise<ServiceTypeListItem | null> => {
  return await _getCommissionServiceType.get({
    CommissionServiceTypeId: baseServiceId,
  });
};

const _getServiceType = new CancellableHelper<ServiceTypeFull>(URL_GET_SERVICE_TYPE, ServiceTypeFull);
export const getServiceType = async (serviceTypeId: number): Promise<ServiceTypeFull> => {
  return await _getServiceType.get({ ServiceTypeId: serviceTypeId });
};
